import {Speed} from '../../../Domain/Speed';
import {round} from './Internal/round';

export function formatPowerSplit(speed: Speed | null): {formatted: string; unit?: string} {
    if (speed === null) {
        return {
            formatted: '-',
        };
    }
    const durationPer500Meters = speed.durationPer500Meters;
    if (durationPer500Meters === null) {
        return {
            formatted: '-',
        };
    }

    const secondsNotRounded = durationPer500Meters.seconds;
    const pace = secondsNotRounded / 500
    const powerSplit = 2.8 / Math.pow(pace, 3)

    return {formatted: round(powerSplit, 2), unit: 'W'};
}

export function formatAveragePowerSplit(speed: Speed | null): {formatted: string; unit?: string} {
    if (speed === null) {
        return {
            formatted: '-',
        };
    }
    const durationPer500Meters = speed.durationPer500Meters;
    if (durationPer500Meters === null) {
        return {
            formatted: '-',
        };
    }

    const secondsNotRounded = durationPer500Meters.seconds;
    const pace = secondsNotRounded / 500
    const powerSplit = 2.8 / Math.pow(pace, 3)

    return {formatted: round(powerSplit, 2), unit: 'W'};
}
